import { useState, useEffect, useCallback, useRef } from "react";
import { useAuth0 } from "@auth0/auth0-react";

const useWidgetData = (fetcher) => {
  const { getAccessTokenSilently } = useAuth0();
  // Keep a ref so Auth0 identity updates don't recreate `load` and trigger extra fetches
  const getTokenRef = useRef(getAccessTokenSilently);
  getTokenRef.current = getAccessTokenSilently;

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      const token = await getTokenRef.current();
      const res = await fetcher(token);
      setData(res);
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [fetcher]); // no longer depends on getAccessTokenSilently

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, retry: load };
};

export default useWidgetData;
